import state from './module-supplier-accept-state';
import mutations from './module-supplier-accept-mutations';
import actions from './module-supplier-accept-actions';
import getters from './module-supplier-accept-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
